import { track_ga } from '@/pages/firebase'

// 下载弹窗曝光
export const showDownloadPopup = (params) => {
  track_ga('download_popup_show', { ...params })
}
// 下载弹窗下载按钮点击
export const clickDownloadPopupBtn = (params) => {
  track_ga('download_popup_click', { ...params })
}
// 下载悬浮球点击
export const showDownloadFloat = (params) => {
  track_ga('download_float_click', { ...params })
}

// 悬浮图标曝光
export const trackFloatBoxShow = (params) => {
  track_ga('page_float_show', { ...params })
}
// 悬浮图标点击
export const trackFloatBoxClick = (params) => {
  track_ga('page_float_click', { ...params })
}
// 底部弹窗曝光
export const trackBottomDialogShow = (params) => {
  track_ga('page_bottomdialog_show', { ...params })
}
// 底部弹窗按钮点击
export const trackBottomDialogClick = (params) => {
  track_ga('page_bottomdialog_click', { ...params })
}
// toast曝光
export const trackToastShow = (params) => {
  track_ga('page_toast_show', { ...params })
}
// 悬浮弹窗展示
export const trackPopupShow = (params) => {
  track_ga('page_popup_show', { ...params })
}
// 悬浮弹窗按钮点击
export const trackPopupClick = (params) => {
  track_ga('page_popup_click', { ...params })
}
